/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol, intCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { getApiTargetInfo } from '../../core'
import { modifierCol, modifiedDateCol } from '../../core/HeaderColTypeProps'
import { connect } from 'react-redux'
import { Select, Input, Button, InputNumber } from 'antd'
import {
  getGadsErrorMgmtInfo,
  postGadsErrorMgmtInfo,
  deleteGadsErrorMgmtInfo,
} from '../../api/pgads.js'
import CommonScreen from './CommonScreen'
// import R from 'ramda'
import { severity } from 'core/utils'

const requiredField = () => <span style={{ color: 'red' }}>*</span>

const headers = [
  strCol({
    ident: 'cards',
    display: 'Card',
    isKey: true,
  }),
  intCol({
    ident: 'errorCode',
    display: 'Error Code',
    isKey: true,
  }),
  strCol({
    ident: 'severity',
    display: 'Severity',
    ...toSelectionColProps(severity),
    isRequired: true,
  }),
  strCol({
    ident: 'error',
    display: 'Error',
    width: 950,
    alignment: 'left',
    isRequired: true,
    ellipsis: true,
  }),

  intCol({
    ident: 'columnPlace',
    display: 'Column Place',
  }),
  intCol({
    ident: 'fromField',
    display: 'From Field',
  }),
  intCol({
    ident: 'toField',
    display: 'To Field',
  }),

  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getGadsErrorMgmtInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postGadsErrorMgmtInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteGadsErrorMgmtInfo(apiTargetInfo)(data)

const title = 'Error Management'

const GadsErrorMgmt = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  // const setData = data => {
  //   setInsertData({ ...insertData, ...data })
  // }

  // const onCancel = () => {
  //   setInsertEvent(false)
  // }

  // useEffect(() => {
  //   setInsertData({ severity: 0 })
  // }, [insertEvent])

  // const validateData = () => {
  //   // const { cards, errorCode, error ,fromField , toField , columnPlace } = insertData
  //   const { errorCode, error } = insertData
  //   if (errorCode === undefined) message.error('Please, Enter Error Code')
  //   else if (error === undefined) message.error('Please, Enter Error to Save')
  //   else return true
  // }

  // const onAdd = ({ hide, retrieve }) => {
  //   const validate = validateData()
  //   if (validate)
  //     modifyTask(props.apiTargetInfo)([insertData]).fork(setErr, _ => {
  //       message.info('Data Saved')
  //       setInsertEvent(!hide)
  //       setInsertData({ severity: 0 })
  //       retrieve && retrieve()
  //     })
  // }
  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td style={{ width: '45px', textAlign: 'right' }}>Card :</td>
            <td style={{ width: '100px' }}>
              <InputNumber
                autoFocus
                placeholder="card"
                style={{ width: '100px' }}
                value={insertData.cards}
                min={0}
                maxLength={10}
                onChange={value =>
                  setInsertData({ ...insertData, cards: value })
                }
              />
            </td>

            <td style={{ width: '100px', textAlign: 'right' }}>
              Error Code{requiredField()} :
            </td>
            <td style={{ width: '100px' }}>
              <InputNumber
                placeholder="error code"
                style={{ width: '100px' }}
                value={insertData.errorCode}
                min={0}
                maxLength={22}
                onChange={value =>
                  setInsertData({ ...insertData, errorCode: value })
                }
              />
            </td>

            <td style={{ width: '80px', textAlign: 'right' }}>Severity :</td>
            <td style={{ width: '100px' }}>
              <Select
                id="severity"
                defaultValue={severity[insertData.severity]}
                style={{ width: '100px' }}
                onChange={value =>
                  setInsertData({ ...insertData, severity: value })
                }
              >
                {Object.keys(severity).map(m => (
                  <Select.Option key={m}>{severity[m]}</Select.Option>
                ))}
              </Select>
            </td>
            <td style={{ width: '95px', textAlign: 'right' }}>
              Column Place :
            </td>
            <td>
              <InputNumber
                placeholder="column place"
                style={{ width: '100px' }}
                value={insertData.columnPlace}
                maxLength={22}
                onChange={e => setInsertData({ ...insertData, columnPlace: e })}
              />
            </td>
            <td />
            <td />
          </tr>
          <tr>
            <td style={{ textAlign: 'right' }}>Error{requiredField()} :</td>
            <td colSpan={3}>
              <Input
                placeholder="error"
                value={insertData.error}
                maxLength={500}
                onChange={e =>
                  setInsertData({ ...insertData, error: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>From Field : </td>
            <td>
              <InputNumber
                placeholder="from field"
                style={{ width: '100px' }}
                value={insertData.fromField}
                maxLength={22}
                onChange={e => setInsertData({ ...insertData, fromField: e })}
              />
            </td>
            <td style={{ textAlign: 'right' }}>To Field : </td>
            <td>
              <InputNumber
                placeholder="To Field"
                style={{ width: '100px' }}
                value={insertData.toField}
                maxLength={22}
                onChange={e => setInsertData({ ...insertData, toField: e })}
              />
            </td>
            <td />
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.cards}
      autoRetrieve
      sortOptions={[{ ident: 'cards', display: 'Card', sortOrder: 'asc' }]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(GadsErrorMgmt)
